import classNames from 'classnames'
import React from 'react'
import './ToggleSeries.scss'

interface ToggleSeriesProps {
  proSelected: boolean
  onClick: () => void
}

export const ToggleSeries: React.FC<ToggleSeriesProps> = (props) => {
  const { proSelected, onClick } = props

  return (
    <div
      className={classNames('ToggleSeries')}
      onClick={onClick}
    >
      <div className={classNames('slider', { iconic: !proSelected })} />
      <div className={classNames('option', { selected: proSelected })}>Pro Series</div>
      <div className={classNames('option', { selected: !proSelected })}>Iconic</div>
    </div>
  )
}